import { render, staticRenderFns } from "./footPage.vue?vue&type=template&id=2942487e&scoped=true&"
import script from "./footPage.vue?vue&type=script&lang=js&"
export * from "./footPage.vue?vue&type=script&lang=js&"
import style0 from "./footPage.vue?vue&type=style&index=0&id=2942487e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2942487e",
  null
  
)

export default component.exports